(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller('supplyChainSettings', supplyChainSettings);

	supplyChainSettings.$inject = ['$rootScope', '$scope', '$timeout', 'customerSettingService', 'storeService', '$experiments'];

	function supplyChainSettings($rootScope, $scope, $timeout, customerSettingService, storeService, $experiments) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;

		var backupValues = {};

		vm.isLeanDNAAdmin = $rootScope.authz.isLeanDNAAdmin();
		vm.isSuperAdmin = $rootScope.authz.isSuperAdmin();
		vm.isCustomerAdmin = $rootScope.authz.isCustomerAdmin();
		vm.hasScheduledDeliveries = $experiments.isEnabled('supply-order-forecast');
		vm.hasHotSheetSettingsVisible = (vm.isLeanDNAAdmin || vm.isCustomerAdmin) && vm.hasScheduledDeliveries;
		vm.scheduledDeliveriesHotSheetFlag = 'No';
		vm.hotSheetVisibleToSupplierFlag = 'No';
		vm.scheduledDeliveriesHotSheetCoverageTimeRange = 45;
		vm.scheduledDeliveriesHotSheetCoverageTimeRangeForInternationalSuppliers;

		vm.saveSettings = saveSettings;
		vm.resetValues = resetValues;
		vm.hasOriginalState = hasOriginalState;
		vm.getdefaultDisplayPeriodLabel = getdefaultDisplayPeriodLabel;
		vm.isLoading = true;
		vm.pastDueDefaultDisplayOptions = [
			{value: 'exclude', label: 'Exclude'},
			{value: 'include', label: 'Include Next Week'},
			{value: 'distribute', label: 'Include Distributed Over Time'}
		];
		vm.defaultDisplayPeriodOptions = [
			{ value: 1, label: '1 week' },
			{ value: 2, label: '2 weeks' },
			{ value: 4, label: '4 weeks' },
			{ value: 6, label: '6 weeks' },
			{ value: 9, label: '2 months' },
			{ value: 13, label: '3 months' },
			{ value: 17, label: '4 months' },
			{ value: 22, label: '5 months' },
			{ value: 26, label: '6 months' }
		];
		vm.dottedLineStartDateOptions = [
			{ value: 'pastDefault', label: 'Time Period Default (Rolling {{defaultDisplayPeriodLabel}})'},
			{ value: 'calendarYearStart', label: 'Start of Calendar Year' }
		];
		vm.procurementLogMetricDataSourceChoices = [
			{
				label: 'Weekly log item (weekly)',
				value: 'weeklyLogItem'
			},
			{
				label: 'Metric results (daily)',
				value: 'leanFactoryMetricResults'
			}
		];
		vm.chatEnabledChoices = [
			{
				label: 'Chat is Enabled',
				value: true
			},
			{
				label: 'Chat is Disabled',
				value: false
			}
		];
		vm.bucketConfigTypeInLOBFirstDayOfFixedWeekChoices = [
			{
				display: 'Monday',
				value: 2
			},
			{
				display: 'Tuesday',
				value: 3
			},
			{
				display: 'Wednesday',
				value: 4
			},
			{
				display: 'Thursday',
				value: 5
			},
			{
				display: 'Friday',
				value: 6
			},
			{
				display: 'Saturday',
				value: 7
			},
			{
				display: 'Sunday',
				value: 1
			}
		];
		vm.bucketConfigType = 'rolling';
		vm.firstDayOfFixedWeek = 2;
		vm.isV2 = $experiments.isEnabled('burnoff-v2');

		init();

		function init() {
			customerSettingService.getCustomerSettings([
				'burnoffDefaultDisplayWeeksPast',
				'burnoffDefaultDisplayWeeksFuture',
				'burnoffDistributePastDuePoTimePeriodWeeks',
				'burnoffDistributePastDuePoPercentage',
				'burnoffDistributePastDueReqTimePeriodWeeks',
				'burnoffDistributePastDueReqPercentage',
				'burnoffPastDueDefaultDisplay',
				'burnoffDottedLineStartDate',
				'bucketConfigTypeInLOB',
				'bucketConfigTypeInLOBFirstDayOfFixedWeek',
				'timePeriodDaysFixedTask',
				'scheduledDeliveriesHotSheetFlag',
				'hotSheetVisibleToSupplierFlag',
				'scheduledDeliveriesHotSheetCoverageTimeRange',
				'scheduledDeliveriesHotSheetCoverageTimeRangeForInternationalSuppliers',
				'staleLookupValueDays',
				'procurementLogMetricDataSource',
				'chatEnabled'
			], adminConfig.factory.id)
				.then(function initDefaultMetricType(settings) {
					vm.weeksPast = (typeof settings.burnoffDefaultDisplayWeeksPast !== 'undefined')
						? settings.burnoffDefaultDisplayWeeksPast : 26;
					vm.weeksFuture = (typeof settings.burnoffDefaultDisplayWeeksFuture !== 'undefined')
						? settings.burnoffDefaultDisplayWeeksFuture : 26;
					vm.distributePastDuePoTimePeriodWeeks = (typeof settings.burnoffDistributePastDuePoTimePeriodWeeks !== 'undefined')
						? settings.burnoffDistributePastDuePoTimePeriodWeeks : 1;
					vm.distributePastDuePoPercentage = (typeof settings.burnoffDistributePastDuePoPercentage !== 'undefined')
						? settings.burnoffDistributePastDuePoPercentage : 1;
					vm.distributePastDueReqTimePeriodWeeks = (typeof settings.burnoffDistributePastDueReqTimePeriodWeeks !== 'undefined')
						? settings.burnoffDistributePastDueReqTimePeriodWeeks : 1;
					vm.distributePastDueReqPercentage = (typeof settings.burnoffDistributePastDueReqPercentage !== 'undefined')
						? settings.burnoffDistributePastDueReqPercentage : 1;
					vm.pastDueDefaultDisplay = (typeof settings.burnoffPastDueDefaultDisplay !== 'undefined')
						? settings.burnoffPastDueDefaultDisplay : 'exclude';
					vm.dottedLineStartDate = (typeof settings.burnoffDottedLineStartDate !== 'undefined')
						? settings.burnoffDottedLineStartDate : 'calendarYearStart';
					vm.bucketConfigType = (typeof settings.bucketConfigTypeInLOB !== 'undefined')
						? settings.bucketConfigTypeInLOB : 'rolling';
					vm.firstDayOfFixedWeek = (typeof settings.bucketConfigTypeInLOBFirstDayOfFixedWeek !== 'undefined')
						? settings.bucketConfigTypeInLOBFirstDayOfFixedWeek : 2;
					vm.timePeriodDaysFixedTask = (typeof settings.timePeriodDaysFixedTask !== 'undefined'
						&& settings.timePeriodDaysFixedTask > -1)
						? settings.timePeriodDaysFixedTask : '';
						
					if (typeof settings.scheduledDeliveriesHotSheetFlag !== 'undefined') {
						vm.scheduledDeliveriesHotSheetFlag = settings.scheduledDeliveriesHotSheetFlag ? 'Yes' : 'No';
					}
					if (typeof settings.hotSheetVisibleToSupplierFlag !== 'undefined') {
						vm.hotSheetVisibleToSupplierFlag = settings.hotSheetVisibleToSupplierFlag ? 'Yes' : 'No';
					}
					if (typeof settings.scheduledDeliveriesHotSheetCoverageTimeRange !== 'undefined') {
						vm.scheduledDeliveriesHotSheetCoverageTimeRange = settings.scheduledDeliveriesHotSheetCoverageTimeRange;
					}
					if (typeof settings.scheduledDeliveriesHotSheetCoverageTimeRangeForInternationalSuppliers !== 'undefined') {
						vm.scheduledDeliveriesHotSheetCoverageTimeRangeForInternationalSuppliers = settings.scheduledDeliveriesHotSheetCoverageTimeRangeForInternationalSuppliers;
					}
					vm.staleLookupValueDays = (typeof settings.staleLookupValueDays !== 'undefined')
						? settings.staleLookupValueDays : 0;
					vm.procurementLogMetricDataSource = (typeof settings.procurementLogMetricDataSource !== 'undefined')
						? settings.procurementLogMetricDataSource : 'leanFactoryMetricResults';
					vm.chatEnabled = (typeof settings.chatEnabled !== 'undefined')
						? settings.chatEnabled : false;

					backupValues.weeksPast = vm.weeksPast;
					backupValues.weeksFuture = vm.weeksFuture;
					backupValues.distributePastDuePoTimePeriodWeeks = vm.distributePastDuePoTimePeriodWeeks;
					backupValues.distributePastDuePoPercentage = vm.distributePastDuePoPercentage;
					backupValues.distributePastDueReqTimePeriodWeeks = vm.distributePastDueReqTimePeriodWeeks;
					backupValues.distributePastDueReqPercentage = vm.distributePastDueReqPercentage;
					backupValues.pastDueDefaultDisplay = vm.pastDueDefaultDisplay;
					backupValues.dottedLineStartDate = vm.dottedLineStartDate;
					backupValues.bucketConfigType = vm.bucketConfigType;
					backupValues.firstDayOfFixedWeek = vm.firstDayOfFixedWeek;
					backupValues.timePeriodDaysFixedTask = vm.timePeriodDaysFixedTask;
					backupValues.scheduledDeliveriesHotSheetFlag = vm.scheduledDeliveriesHotSheetFlag;
					backupValues.hotSheetVisibleToSupplierFlag = vm.hotSheetVisibleToSupplierFlag;
					backupValues.scheduledDeliveriesHotSheetCoverageTimeRange = vm.scheduledDeliveriesHotSheetCoverageTimeRange;
					backupValues.scheduledDeliveriesHotSheetCoverageTimeRangeForInternationalSuppliers = vm.scheduledDeliveriesHotSheetCoverageTimeRangeForInternationalSuppliers;
					backupValues.staleLookupValueDays = vm.staleLookupValueDays;
					backupValues.procurementLogMetricDataSource = vm.procurementLogMetricDataSource;
					backupValues.chatEnabled = vm.chatEnabled;

					vm.isLoading = false;
				});
		}

		function getdefaultDisplayPeriodLabel() {
			for (var i = 0; i < vm.defaultDisplayPeriodOptions.length; i++) {
				if (vm.weeksPast === vm.defaultDisplayPeriodOptions[i].value) {
					return vm.defaultDisplayPeriodOptions[i].label;
				}
			}
		}

		function saveSettings() {
			customerSettingService.saveCustomerSettings({
				burnoffDefaultDisplayWeeksPast: vm.weeksPast,
				burnoffDefaultDisplayWeeksFuture: vm.weeksFuture,
				burnoffDistributePastDuePoTimePeriodWeeks: vm.distributePastDuePoTimePeriodWeeks,
				burnoffDistributePastDuePoPercentage: vm.distributePastDuePoPercentage,
				burnoffDistributePastDueReqTimePeriodWeeks: vm.distributePastDueReqTimePeriodWeeks,
				burnoffDistributePastDueReqPercentage: vm.distributePastDueReqPercentage,
				burnoffPastDueDefaultDisplay: vm.pastDueDefaultDisplay,
				burnoffDottedLineStartDate: vm.dottedLineStartDate,
				bucketConfigTypeInLOB: vm.bucketConfigType,
				bucketConfigTypeInLOBFirstDayOfFixedWeek: vm.firstDayOfFixedWeek,
				timePeriodDaysFixedTask: vm.timePeriodDaysFixedTask,
				scheduledDeliveriesHotSheetFlag: vm.scheduledDeliveriesHotSheetFlag === 'Yes' ? 1 : 0,
				hotSheetVisibleToSupplierFlag: vm.hotSheetVisibleToSupplierFlag === 'Yes' ? 1 : 0,
				scheduledDeliveriesHotSheetCoverageTimeRange: vm.scheduledDeliveriesHotSheetCoverageTimeRange,
				scheduledDeliveriesHotSheetCoverageTimeRangeForInternationalSuppliers: vm.scheduledDeliveriesHotSheetCoverageTimeRangeForInternationalSuppliers,
				staleLookupValueDays: vm.staleLookupValueDays,
				procurementLogMetricDataSource: vm.procurementLogMetricDataSource,
				chatEnabled: vm.chatEnabled
			}, adminConfig.factory.id).then(function (response) {
				if (response === 'Settings saved successfully') {
					$rootScope.$emit('toast', {
						'message': response,
						'success': true
					});
					backupValues.weeksPast = vm.weeksPast;
					backupValues.weeksFuture = vm.weeksFuture;
					backupValues.distributePastDuePoTimePeriodWeeks = vm.distributePastDuePoTimePeriodWeeks;
					backupValues.distributePastDuePoPercentage = vm.distributePastDuePoPercentage;
					backupValues.distributePastDueReqTimePeriodWeeks = vm.distributePastDueReqTimePeriodWeeks;
					backupValues.distributePastDueReqPercentage = vm.distributePastDueReqPercentage;
					backupValues.pastDueDefaultDisplay = vm.pastDueDefaultDisplay;
					backupValues.dottedLineStartDate = vm.dottedLineStartDate;
					backupValues.bucketConfigType = vm.bucketConfigType;
					backupValues.firstDayOfFixedWeek = vm.firstDayOfFixedWeek;
					backupValues.timePeriodDaysFixedTask = vm.timePeriodDaysFixedTask;
					backupValues.scheduledDeliveriesHotSheetFlag = vm.scheduledDeliveriesHotSheetFlag;
					backupValues.hotSheetVisibleToSupplierFlag = vm.hotSheetVisibleToSupplierFlag;
					backupValues.scheduledDeliveriesHotSheetCoverageTimeRange = vm.scheduledDeliveriesHotSheetCoverageTimeRange;
					backupValues.scheduledDeliveriesHotSheetCoverageTimeRangeForInternationalSuppliers = vm.scheduledDeliveriesHotSheetCoverageTimeRangeForInternationalSuppliers;
					backupValues.staleLookupValueDays = vm.staleLookupValueDays;
					backupValues.procurementLogMetricDataSource = vm.procurementLogMetricDataSource;
					backupValues.chatEnabled = vm.chatEnabled;
				} else {
					$rootScope.$emit('toast', {
						'message': response,
						'success': false
					});
				}
			});
		}

		function resetValues() {
			vm.weeksPast = backupValues.weeksPast;
			vm.weeksFuture = backupValues.weeksFuture;
			vm.distributePastDuePoTimePeriodWeeks = backupValues.distributePastDuePoTimePeriodWeeks;
			vm.distributePastDuePoPercentage = backupValues.distributePastDuePoPercentage;
			vm.distributePastDueReqTimePeriodWeeks = backupValues.distributePastDueReqTimePeriodWeeks;
			vm.distributePastDueReqPercentage = backupValues.distributePastDueReqPercentage;
			vm.pastDueDefaultDisplay = backupValues.pastDueDefaultDisplay;
			vm.dottedLineStartDate = backupValues.dottedLineStartDate;
			vm.bucketConfigType = backupValues.bucketConfigType;
			vm.firstDayOfFixedWeek = backupValues.firstDayOfFixedWeek;
			vm.timePeriodDaysFixedTask = backupValues.timePeriodDaysFixedTask;
			vm.scheduledDeliveriesHotSheetFlag = backupValues.scheduledDeliveriesHotSheetFlag;
			vm.hotSheetVisibleToSupplierFlag = backupValues.hotSheetVisibleToSupplierFlag;
			vm.scheduledDeliveriesHotSheetCoverageTimeRange = backupValues.scheduledDeliveriesHotSheetCoverageTimeRange;
			vm.scheduledDeliveriesHotSheetCoverageTimeRangeForInternationalSuppliers = backupValues.scheduledDeliveriesHotSheetCoverageTimeRangeForInternationalSuppliers;
			vm.staleLookupValueDays = backupValues.staleLookupValueDays;
			vm.procurementLogMetricDataSource = backupValues.procurementLogMetricDataSource;
			vm.chatEnabled = backupValues.chatEnabled;
		}

		function hasOriginalState() {
			return (
				vm.weeksPast === backupValues.weeksPast &&
				vm.weeksFuture === backupValues.weeksFuture &&
				vm.distributePastDuePoTimePeriodWeeks === backupValues.distributePastDuePoTimePeriodWeeks &&
				vm.distributePastDuePoPercentage === backupValues.distributePastDuePoPercentage &&
				vm.distributePastDueReqTimePeriodWeeks === backupValues.distributePastDueReqTimePeriodWeeks &&
				vm.distributePastDueReqPercentage === backupValues.distributePastDueReqPercentage &&
				vm.dottedLineStartDate === backupValues.dottedLineStartDate &&
				vm.bucketConfigType === backupValues.bucketConfigType &&
				vm.firstDayOfFixedWeek === backupValues.firstDayOfFixedWeek &&
				vm.timePeriodDaysFixedTask === backupValues.timePeriodDaysFixedTask &&
				vm.scheduledDeliveriesHotSheetFlag === backupValues.scheduledDeliveriesHotSheetFlag &&
				vm.hotSheetVisibleToSupplierFlag === backupValues.hotSheetVisibleToSupplierFlag &&
				vm.scheduledDeliveriesHotSheetCoverageTimeRange === backupValues.scheduledDeliveriesHotSheetCoverageTimeRange && 
				vm.scheduledDeliveriesHotSheetCoverageTimeRangeForInternationalSuppliers === backupValues.scheduledDeliveriesHotSheetCoverageTimeRangeForInternationalSuppliers && 
				vm.staleLookupValueDays === backupValues.staleLookupValueDays &&
				vm.procurementLogMetricDataSource === backupValues.procurementLogMetricDataSource &&
				vm.chatEnabled === backupValues.chatEnabled
			);
		}
	}
})();
